module.exports = __webpack_public_path__ + "static/media/add-manufacturers.9cdccb34.svg";